<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
					<div class="col-xs-12 col-sm-12 col-md-7 col-lg-7">
						<div class="modal-container" @click.stop>
							<!-- Check Type Tabs (Level 1) -->
							<div class="modal-header row" style="justify-content: flex-end">
								<div class="col-lg-5 text-center">
									<button
										type="button"
										class="btn w-100"
										:class="{ 'btn-secondary': isActiveTab == 'Title 1' }"
										@click="isActiveTab = 'Title 1'"
									>
										Check SJ & Koli
									</button>
								</div>
								<div class="col-lg-5">
									<button
										type="button"
										class="btn w-100"
										:class="{ 'btn-secondary': isActiveTab == 'Title 2' }"
										@click="isActiveTab = 'Title 2'"
									>
										Check Rute
									</button>
								</div>
								<div class="col-lg-2">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<!-- Flat NO TO tabs - Only for Check Rute -->
							<div class="no-to-tabs mb-3" v-if="validationTabs.length && isActiveTab == 'Title 2'">
								<div class="d-flex" style="gap: 10px; overflow-x: auto;">
									<button
										v-for="(tab, index) in validationTabs"
										:key="tab.no_to"
										type="button"
										class="btn to-tab-button"
										:class="{ 'active-to-tab': activeToIndex === index }"
										@click="activeToIndex = index"
										style="font: normal normal normal 14px/21px Poppins; white-space: nowrap;"
									>
										{{ tab.no_to }}
									</button>
								</div>
							</div>

							<!-- Check SJ & Koli Content -->
							<div class="modal-body" v-if="isActiveTab == 'Title 1'">
								<div style="max-height: 500px; max-width: 650px;">
									<div class="text-center" v-if="validationTabs.length">
										<!-- Selected NOPOL and NO TO groups -->
										<div class="selection-groups text-left mt-1">
											<div
												v-for="group in nopolGroups"
												:key="group.nopol"
												class="selection-group"
											>
												<div class="selection-label">NOPOL</div>
												<div class="selection-value">: {{ group.nopol }}</div>
												<div class="selection-label">NO TO</div>
												<div class="selection-value">
													<div v-for="(tab, index) in group.tabs" :key="tab.no_to">
														: {{ index + 1 }}. {{ tab.no_to }}
													</div>
												</div>
											</div>
										</div>

										<!-- Statistics -->
										<div class="row text-left mt-2">
											<div class="col-6">
												<h3 style="font: normal normal normal 20px/30px Poppins">
													Total SJ
												</h3>
												<h3 style="font: normal normal normal 20px/30px Poppins">
													Jumlah Unit
												</h3>
												<h3 style="font: normal normal normal 20px/30px Poppins">
													Total SJ Supir
												</h3>
												<h3 style="font: normal normal normal 20px/30px Poppins">
													Total Unit Supir
												</h3>
											</div>
											<div class="col-6">
												<h3 style="font: normal normal normal 20px/30px Poppins">
													: {{ nopolTotalSj }}
												</h3>
												<h3 style="font: normal normal normal 20px/30px Poppins">
													: {{ nopolTotalColy }}
												</h3>
												<h3 style="font: normal normal normal 20px/30px Poppins">
													: {{ nopolDriverSj }}/{{ nopolTotalSj }}
												</h3>
												<h3 style="font: normal normal normal 20px/30px Poppins">
													: {{ nopolDriverColy }}/{{ nopolTotalColy }}
												</h3>
											</div>
										</div>
										<!-- Action Buttons -->
										<div class="row" style="margin-top: 50px" v-if="!isAccountingUser">
											<div class="col-md-6" style="display: flex; justify-content: center">
												<button
													class="btn simple--button mt-3"
													type="button"
													@click="tolakPengecekan"
													style="font: normal normal normal 20px/30px Poppins"
													:disabled="!canApproveSj || isSubmitting"
												>
													Tolak
												</button>
											</div>
											<div class="col-md-6" style="display: flex; justify-content: center">
												<button
													class="btn simple--button mt-3"
													type="button"
													@click="setujuiPengecekan"
													style="
														font: normal normal normal 20px/30px Poppins;
														color: white;
														background-color: #1b698e;
													"
													:disabled="!canApproveSj || isSubmitting"
												>
													Setujui
												</button>
											</div>
										</div>
									</div>
									<div class="text-center pt-5 pb-5" v-else>
										<h1>Loading...</h1>
									</div>
								</div>
							</div>

							<!-- Check Rute Content -->
							<div v-else class="modal-body-rute-container">
								<div class="modal-body modal-body-rute">
									<div style="max-width: 650px">
									<div class="text-center" v-if="currentTab">
										<div class="row text-left mt-1">
											<div class="col">
												<div class="d-flex">
													<h3 style="font: normal normal normal 20px/30px Poppins">
														NO TO
													</h3>
													<h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">
														:
													</h3>
													<h3 style="font: normal normal normal 20px/30px Poppins" class="wrap-text ml-2">
														{{ currentTab.no_to }}
													</h3>
												</div>
												<div class="d-flex mt-2">
													<h3 style="font: normal normal normal 20px/30px Poppins">
														NOPOL
													</h3>
													<h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">
														:
													</h3>
													<h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">
														{{ currentTab.nopol }}
													</h3>
												</div>
												<div class="d-flex mt-2" v-if="currentTab.ruteData && currentTab.ruteData.kode_rute">
													<h3 style="font: normal normal normal 20px/30px Poppins">
														Kode Rute
													</h3>
													<h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">
														:
													</h3>
													<h3 style="font: normal normal normal 20px/30px Poppins" class="ml-2">
														{{ currentTab.ruteData.kode_rute }}
													</h3>
												</div>
											</div>
										</div>

										<div class="divider mt-1"></div>

										<div class="row w-100 mt-1" v-if="currentTab.ruteData && currentTab.ruteData.child && currentTab.ruteData.child.length > 0">
											<div class="col"></div>
											<div class="col-md-12">
												<div
													class="rute-card row w-100"
													v-for="dat in currentTab.ruteData.child"
													v-bind:key="dat.no_to"
												>
													<div class="col-2" style="align-items: center">
														<div class="rute-urutan-box">
															<p v-if="dat.nomor != 0">
																{{ zeroPad(dat.nomor, 2) }}
															</p>
															<p v-else>
																<i class="fas fa-question" style="color: grey"></i>
															</p>
														</div>
													</div>
													<div class="col-7">
														<p class="dealer--name">{{ dat.kd_dealer }}</p>
														<p class="dealer--address">{{ dat.address }}</p>
													</div>
													<div class="col-2">
														<div class="mb-4">
															<p class="dealer--distance text-center pr-4">
																Kode Dealer
															</p>
														</div>
														<div>
															<p class="dealer--distance text-center pr-4">
																{{ dat.dealer_code }}
															</p>
														</div>
													</div>
													<div class="col-3">
														<p class="dealer--distance text-right pr-4">
															+/- {{ dat.distance }}Km
														</p>
													</div>
												</div>
											</div>
											<div class="col"></div>
										</div>
										<div
											style="
												min-height: 400px;
												display: flex;
												align-items: center;
												justify-content: center;
											"
											v-else-if="currentTab.ruteData && currentTab.ruteData.child && currentTab.ruteData.child.length == 0"
										>
											<p
												style="
													margin: 0;
													font-size: 40px;
													text-shadow: 2px 2px 2px grey;
												"
											>
												No Data
											</p>
										</div>
										<div
											style="
												min-height: 400px;
												display: flex;
												align-items: center;
												justify-content: center;
											"
											v-else
										>
											<p
												style="
													margin: 0;
													font-size: 40px;
													text-shadow: 2px 2px 2px grey;
												"
											>
												Loading...
											</p>
										</div>

									</div>
									</div>
								</div>
							</div>

							<!-- Fixed buttons footer for Check Rute -->
							<div class="modal-footer-buttons" v-if="currentTab && isActiveTab == 'Title 2' && !isAccountingUser">
								<div class="row">
									<div class="col-md-6" style="display: flex; justify-content: center">
										<button
											class="btn simple--button"
											type="button"
											@click="updatePengecekanRute(2)"
											style="font: normal normal normal 20px/30px Poppins"
											:disabled="!canUpdateRute || isSubmitting"
										>
											Tolak
										</button>
									</div>
									<div class="col-md-6" style="display: flex; justify-content: center">
										<button
											class="btn simple--button"
											type="button"
											@click="updatePengecekanRute(1)"
											style="
												font: normal normal normal 20px/30px Poppins;
												color: white;
												background-color: #1b698e;
											"
											:disabled="!canUpdateRute || isSubmitting"
										>
											Setujui
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xs-0 col-sm-0 col-md-2 col-lg-2"></div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-3 col-lg-4"></div>
		</div>
	</transition>
</template>

<script>
import {
	getPendingRouteTabs,
	getPendingSjGroups,
	groupTabsByNopol,
	sumSjField
} from './pengecekanMultiple'

export default {
	data() {
		return {
			apiData: {
				tabs: []
			},
			activeToIndex: 0,
			isActiveTab: 'Title 1',
			isSubmitting: false
		}
	},
	props: ['data'],
	components: {},
	computed: {
		validationTabs() {
			return this.apiData.tabs
		},
		nopolGroups() {
			return groupTabsByNopol(this.validationTabs)
		},
		currentTab() {
			return this.validationTabs[this.activeToIndex] || null
		},
		nopolTotalSj() {
			return sumSjField(this.validationTabs, 'total_sj')
		},
		nopolTotalColy() {
			return sumSjField(this.validationTabs, 'total_coly')
		},
		nopolDriverSj() {
			return sumSjField(this.validationTabs, 'driver_sj')
		},
		nopolDriverColy() {
			return sumSjField(this.validationTabs, 'driver_coly')
		},
		pendingSjGroups() {
			return getPendingSjGroups(this.validationTabs)
		},
		pendingRouteTabs() {
			return getPendingRouteTabs(this.validationTabs)
		},
		canApproveSj() {
			return this.pendingSjGroups.length > 0
		},
		canUpdateRute() {
			return this.pendingRouteTabs.length > 0
		},
		isAccountingUser() {
			const user = this.$store.getters.currentUser
			return user && user.role === 'ACCOUNTING'
		}
	},
	mounted() {
		this.loadApi()
	},
	watch: {},
	methods: {
		async loadApi(options = {}) {
			const showError = options.showError !== false

			try {
				const selectedItems = this.data.selectedItems || []
				const noToList = selectedItems.map(item => item.no_to).join(',')

				if (!noToList) {
					this.apiData = { tabs: [] }
					return
				}

				const resp = await this.$http.get('/api/validation/check-sj-rute', {
					params: { no_to: noToList }
				})
				const tabs = resp.data && resp.data.data && Array.isArray(resp.data.data.tabs)
					? resp.data.data.tabs
					: []

				this.apiData = { tabs }
				this.activeToIndex = Math.min(this.activeToIndex, Math.max(tabs.length - 1, 0))
			} catch (err) {
				if (showError) {
					this.$swal.fire({
						title: 'Error!',
						text: 'Gagal memuat data. Silakan coba lagi.',
						icon: 'error'
					})
				}
			}
		},
		zeroPad(num, places) {
			return String(num).padStart(places, '0')
		},
		async settleRequests(requestDefinitions) {
			return Promise.all(requestDefinitions.map(definition => {
				return definition.request()
					.then(() => ({ ...definition, success: true }))
					.catch(error => ({ ...definition, success: false, error }))
			}))
		},
		async finishBulkAction(results, skippedCount, failureType, successText) {
			const successful = results.filter(result => result.success)
			const failed = results.filter(result => !result.success)
			const successfulCount = successful.reduce((count, result) => count + result.count, 0)

			if (failed.length) {
				await this.loadApi({ showError: false })
				this.$emit('refreshTable')
				this.$swal.fire({
					title: 'Sebagian Gagal!',
					text: `Berhasil: ${successfulCount} TO. Dilewati: ${skippedCount} TO. Gagal (${failureType}): ${failed.map(result => result.label).join(', ')}.`,
					icon: 'error'
				})
				return
			}

			this.$swal.fire({
				title: 'Sukses!',
				text: successText,
				icon: 'success'
			})
			this.$emit('refreshTable')
			this.$emit('closeModal')
		},
		setujuiPengecekan() {
			return this.updatePengecekanSj(1)
		},
		tolakPengecekan() {
			return this.updatePengecekanSj(2)
		},
		async updatePengecekanSj(status) {
			if (!this.canApproveSj || this.isSubmitting) return

			this.isSubmitting = true
			const pendingCount = this.pendingSjGroups.reduce((count, group) => count + group.tabs.length, 0)
			const skippedCount = this.validationTabs.length - pendingCount
			const requests = this.pendingSjGroups.map(group => ({
				label: group.nopol,
				count: group.tabs.length,
				request: () => this.$http.put('/api/validation/update-to', {
					status,
					nopol: group.nopol,
					no_to: group.tabs.map(tab => tab.no_to).join(',')
				})
			}))

			try {
				const results = await this.settleRequests(requests)
				await this.finishBulkAction(
					results,
					skippedCount,
					'NOPOL',
					`Pengecekan berhasil ${status === 1 ? 'disetujui.' : 'ditolak.'}`
				)
			} finally {
				this.isSubmitting = false
			}
		},
		async updatePengecekanRute(status) {
			if (!this.canUpdateRute || this.isSubmitting) return

			this.isSubmitting = true
			const skippedCount = this.validationTabs.length - this.pendingRouteTabs.length
			const requests = this.pendingRouteTabs.map(tab => ({
				label: tab.no_to,
				count: 1,
				request: () => this.$http.put('/api/validation/update-rute', {
					insert_id: tab.ruteData.child
						.map(item => item.insert_id)
						.filter(insertId => insertId !== null && insertId !== undefined)
						.join(','),
					no_to: tab.no_to,
					nopol: tab.nopol,
					status
				})
			}))

			try {
				const results = await this.settleRequests(requests)
				await this.finishBulkAction(
					results,
					skippedCount,
					'NO TO',
					`Pengecekan rute berhasil ${status === 1 ? 'disetujui.' : 'ditolak.'}`
				)
			} finally {
				this.isSubmitting = false
			}
		}
	}
}
</script>

<style scoped>
.modal-mask {
	position: fixed;
	z-index: 1020;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	width: 100%;
	margin: 0px auto;
	padding: 20px 30px;
	background-color: #fff;
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 20px 0;
}

.modal-default-button {
	float: right;
}

.wrap-text {
	word-wrap: break-word;
}

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}

.modal-body {
	margin: 0;
}

.modal-body .moduleLine {
	margin-bottom: 0vh;
}

.modal-body .moduleLine a {
	text-decoration: none;
}

.modal-body .moduleLine .moduleBox:hover {
	background-color: #e0e0e0;
	transition: background-color 0.7s ease;
	color: #212121;
	transition: color 0.7s ease;
}

.modal-body .moduleLine .moduleBox {
	border: 1px solid #bdbdbd;
	border-radius: 20px;
	padding: 20px 0;
	color: black;
	margin-bottom: 3vh;
}

.modal-body .moduleLine .moduleBox i {
	font-size: 5vh;
}

h3.modalHeadline {
	margin: 0 0 20px 0;
	font-weight: bold;
	text-align: center;
}

input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.modal-container {
	border: 1px solid #1f1f1f;
}

.modal-body {
	max-height: 80vh;
	overflow-y: auto;
	overflow-x: auto;
}

.modal-body-rute-container {
	display: flex;
	flex-direction: column;
	max-height: 60vh;
}

.modal-body-rute {
	flex: 1;
	overflow-y: auto;
	overflow-x: auto;
	margin: 20px 0 0 0;
	max-height: 50vh;
}

.modal-footer-buttons {
	flex-shrink: 0;
	padding: 20px 0;
	border-top: 1px solid #e0e0e0;
	background-color: white;
	margin: 0;
}

.innerBox {
	padding: 0.8em 1.5em;
	border: 1px solid #eeeeee;
	border-radius: 5px;
	background-color: white;
	box-shadow: 2px 2px 5px #e0e0e0;
}

.hoverable:hover {
	cursor: pointer;
}

.modal-stats {
	margin: 0 auto;
}

.modal-stats th {
	font: normal normal normal 13px/20px Poppins;
	padding-right: 20px;
}

.modal-stats td {
	font: normal normal normal 20px/28px Poppins;
}

.divider {
	width: 100%;
	height: 3px;
	background-color: grey;
}

.rute-card {
	background: #ffffff 0% 0% no-repeat padding-box;
	box-shadow: 0px 0px 6px #83838329;
	border-radius: 8px;
	margin: 20px 0;
	padding: 20px 0;
}

.rute-card > div {
	display: flex;
	flex-direction: column;
	align-items: left;
	justify-content: center;
}

.rute-card .rute-urutan-box {
	border: 5px solid #f77070;
	border-radius: 200px;
	height: 50px;
	width: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.rute-card .rute-urutan-box p {
	font: normal normal normal 16px/18px Poppins;
	font-weight: bold;
	margin: 0;
}

.rute-card .dealer--name {
	font: normal normal 500 18px/20px Poppins;
	margin-bottom: 10px;
	color: #606060;
}

.rute-card .dealer--address {
	font: normal normal 500 14px/16px Poppins;
	margin: 0;
	color: #606060;
}

.rute-card .dealer--distance {
	font: normal normal 500 14px/16px Poppins;
	margin: 0;
	color: #606060;
}

.simple--button {
	width: 100%;
	box-shadow: 0px 0px 6px #00000029;
	border: 1px solid #000000;
	border-radius: 8px;
}

.selection-groups {
	max-height: 220px;
	overflow-y: auto;
}

.selection-group {
	display: grid;
	grid-template-columns: minmax(120px, 40%) minmax(0, 60%);
	row-gap: 8px;
	padding: 8px 0;
	border-bottom: 1px solid #e4e4e4;
	font: normal normal normal 20px/30px Poppins;
}

.selection-group:last-child {
	border-bottom: 0;
}

.selection-label,
.selection-value {
	min-width: 0;
	word-break: break-word;
}

/* Flat NO TO tabs */
.no-to-tabs {
	border-bottom: 2px solid #e0e0e0;
	padding-bottom: 0;
}

.to-tab-button {
	background-color: transparent;
	border: none;
	border-bottom: 3px solid transparent;
	border-radius: 0;
	padding: 10px 20px;
	color: #999;
	transition: all 0.3s ease;
	font-weight: normal;
	outline: none;
	box-shadow: none;
}

.to-tab-button:hover {
	background-color: transparent;
	color: #f36f21;
}

.to-tab-button:focus {
	outline: none;
	box-shadow: none;
}

.to-tab-button:active {
	outline: none;
	box-shadow: none;
}

.active-to-tab {
	background-color: transparent !important;
	color: #f36f21 !important;
	border-bottom: 3px solid #f36f21 !important;
	font-weight: bold;
	outline: none !important;
	box-shadow: none !important;
}

.title {
	font-size: 40px;
	color: #525252;
	text-align: center;
}

.sub--title {
	color: red;
	margin-bottom: 40px;
	text-align: center;
}
</style>
